import { ContractorIdsByTrade } from './ScanRoot/ScanRootSchemas';

const emptyContractorIdsByTrade: ContractorIdsByTrade = {};
export const getResolvedContractorId = (
  trade: string | null | undefined,
  assignedContractorId?: string | null | undefined,
  defaultContractorsByTrade: ContractorIdsByTrade = emptyContractorIdsByTrade,
) => {
  assignedContractorId ||= undefined;
  return (
    assignedContractorId
      ?? defaultContractorsByTrade[trade as any]
      ?? defaultContractorsByTrade.general
  ) || undefined; // '', 0 and null will be returned as undefined
};

export const contractorHasChanged = (
  trade: string,
  assignedContractorId?: string | null,
  baselineAssignedContractorId?: string | null,
  defaultContractorsByTrade: ContractorIdsByTrade = emptyContractorIdsByTrade,
  baselineDefaultContractorsByTrade: ContractorIdsByTrade = emptyContractorIdsByTrade,
) => {
  const effectiveAssignedContractorId = getResolvedContractorId(trade, assignedContractorId, defaultContractorsByTrade);
  const effectiveBaselineAssignedContractorId = getResolvedContractorId(trade, baselineAssignedContractorId, baselineDefaultContractorsByTrade);

  return effectiveAssignedContractorId !== effectiveBaselineAssignedContractorId;
};
